import React from 'react';

import LazyLoadedThumbnail from 'modules/menu/components/LazyLoadedThumbnail';
import EmptyThumbnail from 'modules/menu/items/components/EmptyThumbnail';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';
import { useSelectionInfoContext } from 'modules/shared-menu/contexts/SelectionInfoContext';

import { MinimalOfferActions } from './MinimalOfferActions';
import * as S from './MinimalOfferHeader.styles';
import { useSelectionData } from '../../../../hooks/useSelectionData';
import { Offer, Option } from '../../types';

type MinimalOfferHeaderProps = {
  className?: string;
  item: Offer;
  activeOption: Option;
};

export const MinimalOfferHeader = ({ className, item, activeOption }: MinimalOfferHeaderProps) => {
  const { selection } = useSelectionData();
  const { vlmeConfig } = useSelectionInfoContext();
  const isSharedVenue = !!vlmeConfig?.isSharedVenue;
  const menuPermissions = useOfferingMenuPermissionsContext();

  const primaryLanguage = selection.primary_language;
  const name = item.name.find(t => t.lang === primaryLanguage) || item.name[0];
  const description = item.description
    ? item.description.find(t => t.lang === primaryLanguage) || item.description[0]
    : '';

  return (
    <S.Root className={className}>
      <S.Header>
        <S.Left>
          <S.ThumbnailContainer>
            {item.image ? (
              <LazyLoadedThumbnail alt={name.value} blurhash={item.image_blurhash ?? null} src={item.image} />
            ) : (
              <EmptyThumbnail />
            )}
          </S.ThumbnailContainer>
          <S.NameAndDescription>
            <S.NameContainer>
              <S.Name dir="auto" lang={name.lang}>
                {name.value}
              </S.Name>
            </S.NameContainer>
            {description && (
              <S.Description dir="auto" lang={description.lang}>
                {description.value}
              </S.Description>
            )}
          </S.NameAndDescription>
        </S.Left>
        {!isSharedVenue && menuPermissions.contentEdit && (
          <S.Right>
            <MinimalOfferActions offer={item} activeOption={activeOption} />
          </S.Right>
        )}
      </S.Header>
    </S.Root>
  );
};
